<template>
    <Transition
        enter-active-class="transition ease-out duration-200"
        enter-from-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="transition ease-in duration-200"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
    >
        <div
            v-if="isLoading"
            data-spec-class="overlay-loading"
            class="absolute inset-0 z-10 flex items-center justify-center rounded-sm bg-gray-150/75 dark:bg-gray-800/75"
        >
            <div class="flex flex-col items-center gap-2 font-bold text-tertiary">
                <BaseSpinner :size="SizeAll.Huge" />
                <span>
                    <slot>{{ t('general.updatingData') }}</slot>
                </span>
            </div>
        </div>
    </Transition>
</template>

<script lang="ts" setup>
import { defineProps } from 'vue';
import { useI18n } from 'vue-i18n';
import BaseSpinner from './BaseSpinner.vue';
import { SizeAll } from '@/types';

interface Props {
    isLoading: boolean;
}

defineProps<Props>();

const { t } = useI18n();
</script>
